import { render, staticRenderFns } from "./ToDressRoom.vue?vue&type=template&id=13a4deee"
import script from "./ToDressRoom.vue?vue&type=script&lang=js"
export * from "./ToDressRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports